import { render, staticRenderFns } from "./ModulePendenciesDisapproved.vue?vue&type=template&id=10bc100a"
import script from "./ModulePendenciesDisapproved.vue?vue&type=script&lang=js"
export * from "./ModulePendenciesDisapproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports